/*
 * HTTP のヘルパライブラリ
 */
import Axios from 'axios'
import * as errors from './errors'

//
// HTTP ステータスコード
//
export const Continue = 100
export const SwitchingProtocols = 101
export const Processing = 102

export const OK = 200
export const Created = 201
export const Accepted = 202
export const NonAuthoritativeInfo = 203
export const NoContent = 204
export const ResetContent = 205
export const PartialContent = 206
export const MultiStatus = 207
export const AlreadyReported = 208
export const IMUsed = 226

export const MultipleChoices = 300
export const MovedPermanently = 301
export const Found = 302
export const SeeOther = 303
export const NotModified = 304
export const UseProxy = 305

export const TemporaryRedirect = 307
export const PermanentRedirect = 308

export const BadRequest = 400
export const Unauthorized = 401
export const PaymentRequired = 402
export const Forbidden = 403
export const NotFound = 404
export const MethodNotAllowed = 405
export const NotAcceptable = 406
export const ProxyAuthRequired = 407
export const RequestTimeout = 408
export const Conflict = 409
export const Gone = 410
export const LengthRequired = 411
export const PreconditionFailed = 412
export const RequestEntityTooLarge = 413
export const RequestURITooLong = 414
export const UnsupportedMediaType = 415
export const RequestedRangeNotSatisfiable = 416
export const ExpectationFailed = 417
export const Teapot = 418
export const UnprocessableEntity = 422
export const Locked = 423
export const FailedDependency = 424
export const UpgradeRequired = 426
export const PreconditionRequired = 428
export const TooManyRequests = 429
export const RequestHeaderFieldsTooLarge = 431
export const UnavailableForLegalReasons = 451

export const InternalServerError = 500
export const NotImplemented = 501
export const BadGateway = 502
export const ServiceUnavailable = 503
export const GatewayTimeout = 504
export const HTTPVersionNotSupported = 505
export const VariantAlsoNegotiates = 506
export const InsufficientStorage = 507
export const LoopDetected = 508
export const NotExtended = 510
export const NetworkAuthRequired = 51

export function statusText (code) {
  switch (code) {
    case Continue:
      return 'Continue'
    case SwitchingProtocols:
      return 'Switching Protocols'
    case Processing:
      return 'Processing'

    case OK:
      return 'OK'
    case Created:
      return 'Created'
    case Accepted:
      return 'Accepted'
    case NonAuthoritativeInfo:
      return 'Non-Authoritative Information'
    case NoContent:
      return 'No Content'
    case ResetContent:
      return 'Reset Content'
    case PartialContent:
      return 'Partial Content'
    case MultiStatus:
      return 'Multi-Status'
    case AlreadyReported:
      return 'Already Reported'
    case IMUsed:
      return 'IM Used'

    case MultipleChoices:
      return 'Multiple Choices'
    case MovedPermanently:
      return 'Moved Permanently'
    case Found:
      return 'Found'
    case SeeOther:
      return 'See Other'
    case NotModified:
      return 'Not Modified'
    case UseProxy:
      return 'Use Proxy'

    case TemporaryRedirect:
      return 'Temporary Redirect'
    case PermanentRedirect:
      return 'Permanent Redirect'

    case BadRequest:
      return 'Bad Request'
    case Unauthorized:
      return 'Unauthorized'
    case PaymentRequired:
      return 'Payment Required'
    case Forbidden:
      return 'Forbidden'
    case NotFound:
      return 'Not Found'
    case MethodNotAllowed:
      return 'Method Not Allowed'
    case NotAcceptable:
      return 'Not Acceptable'
    case ProxyAuthRequired:
      return 'Proxy Authentication Required'
    case RequestTimeout:
      return 'Request Timeout'
    case Conflict:
      return 'Conflict'
    case Gone:
      return 'Gone'
    case LengthRequired:
      return 'Length Required'
    case PreconditionFailed:
      return 'Precondition Failed'
    case RequestEntityTooLarge:
      return 'Request Entity Too Large'
    case RequestURITooLong:
      return 'Request-URI Too Long'
    case UnsupportedMediaType:
      return 'Unsupported Media Type'
    case RequestedRangeNotSatisfiable:
      return 'Requested Range Not Satisfiable'
    case ExpectationFailed:
      return 'Expectation Failed'
    case Teapot:
      return 'Teapot'
    case UnprocessableEntity:
      return 'Unprocessable Entity'
    case Locked:
      return 'Locked '
    case FailedDependency:
      return 'Failed Dependency'
    case UpgradeRequired:
      return 'Upgrade Required'
    case PreconditionRequired:
      return 'Precondition Required'
    case TooManyRequests:
      return 'Too Many Requests'
    case RequestHeaderFieldsTooLarge:
      return 'Request Header Fields Too Large'
    case UnavailableForLegalReasons:
      return 'Unavailable For Legal Reasons'

    case InternalServerError:
      return 'Internal Server Error'
    case NotImplemented:
      return 'Not Implemented'
    case BadGateway:
      return 'Bad Gateway'
    case ServiceUnavailable:
      return 'Service Unavailable'
    case GatewayTimeout:
      return 'Gateway Timeout'
    case HTTPVersionNotSupported:
      return 'HTTP Version Not Supported'
    case VariantAlsoNegotiates:
      return 'Variant Also Negotiates'
    case InsufficientStorage:
      return 'Insufficient Storage'
    case LoopDetected:
      return 'Loop Detected'
    case NotExtended:
      return 'Not Extended'
    case NetworkAuthRequired:
      return 'Network Authentication Required'
  }
  return ''
}

//
// api アクセッサ
//
const api = Axios.create({
  baseURL: process.env.BASE_URL + 'api/',

  validateStatus (status) {
    return true
  }
})

//
// エラー定数
//
export const FAILED = 'api:failed'

//
// StatusError
//
export class StatusError {
  constructor (resp) {
    this.resp = resp
  }

  get errs () {
    const errs = [
      'サーバとの通信でエラーが発生しました。',
      `${this.resp.status} ${this.resp.statusText}`,
      `${this.resp.config.method.toUpperCase()} ${this.resp.request.responseURL}`
    ]
    if (this.resp.config.data !== undefined) {
      errs.push(`data: ${JSON.stringify(this.resp.config.data)}`)
    }

    return errs
  }
}

//
// request 関数
//
export async function request (run) {
  // 通信処理を実行する
  const result = await run(api)

  // StatusError が返されたらエラーとみなす
  if (result instanceof StatusError) {
    errors.post(result.errs)
    return FAILED
  }

  // それ以外は値として返す
  return result
}
